require('./bootstrap');

import { createApp, h } from 'vue';
import { createInertiaApp } from '@inertiajs/inertia-vue3';
import { InertiaProgress } from '@inertiajs/progress';
// import { createI18n } from 'vue3-i18n';

const appName = window.document.getElementsByTagName('title')[0]?.innerText || 'Laravel';

const lut = [];
for (let i=0; i<256; i++) {
    lut[i] = (i<16?'0':'')+(i).toString(16);
}

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) => require(`./Pages/${name}.vue`),
    setup({el, app, props, plugin}) {
        // const i18n = createI18n({
        //     locale: localStorage.getItem('lang') || navigator.language.substring(0,2) || 'en',
        //     fallbackLocale: 'en',
        //     messages: require('./translates'),
        // });
        // document.documentElement.lang = i18n.getLocale();

        return createApp({render: () => h(app, props)})
            .use(plugin)
            // .use(i18n)
            .mixin({
                methods: {
                    route,
                    access(namespace, permission) {
                        const {permissions} = props.initialPage.props.auth;
                        if(typeof permissions === 'object'
                            && permissions.hasOwnProperty(namespace)
                            && permissions[namespace].hasOwnProperty(permission))
                            return permissions[namespace][permission];
                        console.error('Access not found', {namespace, permission});
                        return false;
                    },
                    uuid() {
                        const d0 = Math.random() * 0xffffffff | 0;
                        const d1 = Math.random() * 0xffffffff | 0;
                        const d2 = Math.random() * 0xffffffff | 0;
                        const d3 = Math.random() * 0xffffffff | 0;
                        return lut[d0 & 0xff] + lut[d0 >> 8 & 0xff] + lut[d0 >> 16 & 0xff] + lut[d0 >> 24 & 0xff] + '-' +
                            lut[d1 & 0xff] + lut[d1 >> 8 & 0xff] + '-' + lut[d1 >> 16 & 0x0f | 0x40] + lut[d1 >> 24 & 0xff] + '-' +
                            lut[d2 & 0x3f | 0x80] + lut[d2 >> 8 & 0xff] + '-' + lut[d2 >> 16 & 0xff] + lut[d2 >> 24 & 0xff] +
                            lut[d3 & 0xff] + lut[d3 >> 8 & 0xff] + lut[d3 >> 16 & 0xff] + lut[d3 >> 24  & 0xff];
                    },
                }
            })
            .mount(el);
    },
}).then();

InertiaProgress.init({ color: '#4B5563' });

